import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import Image from 'next/image';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { type FC } from 'react';

import Cez from '@/assets/cez.png';
import Button from '@/components/Button';
import Text from '@/components/Text';
import { queries } from '@/queries';
import { postCezCVContextFromCandidateId } from '@/services/cezCvGenerator';

import ButtonWithLabelOnHover from '../../ButtonWithLabelOnHover';
import type { Row, Table } from './types';

type Props = {
  row: Row;
  table: Table;
};
const CezResume: FC<Props> = ({ row, table }) => {
  const { getIsSomeRowsSelected } = table;

  const { push } = useRouter();

  const queryClient = useQueryClient();

  const { mutate } = useMutation({
    mutationFn: postCezCVContextFromCandidateId,
    mutationKey: ['postCezCVContextFromCandidateId'],
    onSuccess: (queryData) => {
      queryClient.invalidateQueries(queries.cvGenerator.list._def);
      queryClient.invalidateQueries(queries.externalCandidates.list._def);
      push({
        pathname: '/dashboard/generator/cez/[id]',
        query: { id: queryData.id.toString() },
      });
    },
  });
  if (row.original.inetumCez && row.original.inetumCez.length > 0)
    return (
      <Link
        href={{
          pathname: `/dashboard/generator/cez/[id]`,
          query: {
            id: row.original.inetumCez?.[0].id.toString(),
            tabs: row.original.cvContexts
              .slice(1)
              .map(({ id }) => id.toString()),
          },
        }}
      >
        <Button
          variant="whiteOutline"
          size="sm"
          tabIndex={-1}
          data-joyride="resume"
          iconClassName="text-sm"
          className="w-max !py-0.5 hover:bg-neutral-800"
        >
          <Image src={Cez} alt="" className="w-8 rounded" />
          <Text variant="body-caption">Open</Text>
        </Button>
      </Link>
    );
  return (
    <div className="flex flex-row">
      <ButtonWithLabelOnHover
        icon={faPlus}
        disabled={getIsSomeRowsSelected()}
        onClick={() => mutate({ id: row.original.id, forceGenerate: true })}
        suffixElement={<Image src={Cez} alt="" className="w-8 rounded" />}
      >
        Generate
      </ButtonWithLabelOnHover>
    </div>
  );
};

export default CezResume;
